import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  getDateRangeString,
  removeSecondFromDateString,
} from "../../../../libs/dateFormat";

import { SatisfactionRequest } from "../../../../services/userReportServices";
import { postEtcSatisfaction } from "../../../../services/etcServices";

import useFullScreenLoading from "../../../../hooks/useFullScreenLoading";

import StickyHeader from "../../../../components/Layout/StickyHeader";
import HorizontalRule from "../../../../components/Rule/Horizontal";
import BottomGroup from "../../../../components/Button/Group";
import CommonButton from "../../../../components/Button";
import useSimplePopup from "../../../../hooks/useSimplePopup";
import UserSatisfactionPopup from "../../../../components/Popup/UserSatisfaction";
import ProgressIconGroup from "../../../../components/Service/Rent/ProgressIconGroup";

type Props = {};

export default function ServiceRentalReturned(props: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [popup, setPopup] = useState("");
  const [simplePopupComponent, { open }] = useSimplePopup({});
  const [isLoading, setIsLoading] = useState(false);
  const loadingComponent = useFullScreenLoading({ isLoading });

  return (
    <div>
      {loadingComponent}
      <StickyHeader
        title="대여하기"
        onBackClick={() =>
          navigate(`/service/rental/${location?.state?.rentStockId}`)
        }
        className="px-5"
      />

      <div className="flex flex-col gap-10 items-center pb-5">
        <div className="px-5 h-[370px] w-full flex flex-col items-center justify-center gap-[30px] flex-shrink-0">
          <div className="flex flex-col py-2.5 justify-evenly items-center h-full">
            <ProgressIconGroup step={2} />
            <div className="flex flex-col gap-2.5 items-center">
              <div className=" text-2xl font-semibold leading-[140%]">
                반납 완료
              </div>
              <div className=" text-brand-neutral-70 text-sm leading-[18px] whitespace-pre-line text-center">
                {"이용에 만족하셨나요?\n다음에 또 이용해주세요."}
              </div>
            </div>
          </div>
        </div>

        <div className="w-full px-5 flex flex-col">
          <div className="flex p-5 flex-col items-center justify-center bg-brand-weather-badge-background rounded-[3px]">
            <div className="flex justify-center items-start gap-2.5 self-stretch text-brand-neutral-80 text-sm leading-6 pb-5">
              안내 사원에게 이 화면을 보여주세요
            </div>
            <HorizontalRule margin="0" className="border-brand-neutral-20" />
            <div className="flex items-start gap-2.5 self-stretch">
              <div className="flex flex-col items-start w-[90px] py-3 gap-2.5 text-brand-neutral-60 text-sm leading-[18px]">
                이용 번호
              </div>
              <div className="flex p-2.5 flex-col items-start gap-[5px] flex-[1_0_0]">
                {location?.state?.goodsServiceId}
              </div>
            </div>
            <div className="flex items-start gap-2.5 self-stretch">
              <div className="flex flex-col items-start w-[90px] py-3 gap-2.5 text-brand-neutral-60 text-sm leading-[18px]">
                이용 공간
              </div>
              <div className="flex p-2.5 flex-col items-start gap-[5px] flex-[1_0_0]">
                {location?.state?.goodsName}
              </div>
            </div>
            <div className="flex items-start gap-2.5 self-stretch">
              <div className="flex flex-col items-start w-[90px] py-3 gap-2.5 text-brand-neutral-60 text-sm leading-[18px]">
                이용 기간
              </div>
              <div className="flex p-2.5 flex-col items-start gap-[5px] flex-[1_0_0] whitespace-pre-line">
                {getDateRangeString(
                  location.state?.rentalAt,
                  location.state?.returnDueAt
                )}
              </div>
            </div>
            <div className="flex items-start gap-2.5 self-stretch">
              <div className="flex flex-col items-start w-[90px] py-3 gap-2.5 text-brand-neutral-60 text-sm leading-[18px]">
                반납 일시
              </div>
              <div className="flex p-2.5 flex-col items-start gap-[5px] flex-[1_0_0] whitespace-pre-line">
                {removeSecondFromDateString(location.state?.actualReturnAt)}
              </div>
            </div>
          </div>
        </div>
      </div>

      <BottomGroup className="flex gap-1.5 px-5 py-2.5 h-[70px]">
        <CommonButton
          variant="tertiary"
          className="flex flex-[1_0_0] justify-center items-center px-4 py-[11px] border border-brand-primary-gray-20 rounded-[3px] text-brand-neutral-60 !text-sm"
          onClick={() => {
            if (location?.state?.goodsServiceId) {
              navigate(`/history/rent/${location?.state?.goodsServiceId}`);
            } else {
              open("해당 물품 아이디 조회에 실패했습니다.");
            }
          }}
        >
          상세 보기
        </CommonButton>
        <CommonButton
          variant="tertiary"
          className="flex flex-[1_0_0] justify-center items-center px-4 py-[11px] border border-brand-primary-gray-20 rounded-[3px] text-brand-neutral-60 !text-sm"
          onClick={() => {
            setPopup("satisfaction");
          }}
        >
          만족도 평가
        </CommonButton>
      </BottomGroup>

      <UserSatisfactionPopup
        popup={popup}
        setPopup={(popup) => setPopup(popup)}
        setIsLoading={(isLoading) => setIsLoading(isLoading)}
        open={open}
        postSatisfaction={async (satisfaction: SatisfactionRequest) => {
          await postEtcSatisfaction(location?.state?.goodsServiceId as string, {
            ...satisfaction,
            serviceName: "rental",
          });
        }}
        subTitle="이용에 만족하셨나요?"
      />
      {simplePopupComponent}
    </div>
  );
}
